import React, { useEffect, useState } from 'react';
import { Html5Qrcode, Html5QrcodeSupportedFormats } from 'html5-qrcode';

const QRScanner = ({ onScan, onClose, isOpen }) => {
  const [html5QrCode, setHtml5QrCode] = useState(null);
  const [cameras, setCameras] = useState([]);
  const [selectedCamera, setSelectedCamera] = useState(null);
  const [error, setError] = useState(null);
  const [isScanning, setIsScanning] = useState(false);

  useEffect(() => {
    if (!isOpen) return;

    Html5Qrcode.getCameras().then(devices => {
      if (devices && devices.length) {
        setCameras(devices);
        const backCamera = devices.find(device => 
          device.label.toLowerCase().includes('back') || 
          device.label.toLowerCase().includes('environment')
        );
        setSelectedCamera(backCamera ? backCamera.id : devices[0].id);
      } else {
        setError("No cameras found on this device");
      }
    }).catch(err => {
      console.error("Error getting cameras:", err);
      setError("Unable to access camera. Please check permissions.");
    });

    return () => {
      if (html5QrCode && isScanning) {
        html5QrCode.stop().catch(err => console.error("Error stopping scanner:", err));
      }
    };
  }, [isOpen]);

  useEffect(() => {
    if (!selectedCamera || !isOpen) return;

    const qrCodeInstance = new Html5Qrcode("qr-reader");
    setHtml5QrCode(qrCodeInstance);

    const config = {
      fps: 10,
      qrbox: { width: 250, height: 250 },
      formatsToSupport: [
        Html5QrcodeSupportedFormats.QR_CODE,
        Html5QrcodeSupportedFormats.UPC_A,
        Html5QrcodeSupportedFormats.UPC_E,
        Html5QrcodeSupportedFormats.EAN_13,
        Html5QrcodeSupportedFormats.EAN_8,
        Html5QrcodeSupportedFormats.CODE_128,
        Html5QrcodeSupportedFormats.CODE_39
      ]
    };

    qrCodeInstance.start(
      selectedCamera,
      config,
      (decodedText, decodedResult) => {
        onScan(decodedText);
        
        qrCodeInstance.stop().then(() => {
          setIsScanning(false);
        }).catch(err => console.error("Error stopping scanner:", err));
      },
      (errorMessage) => {
        // Scan failure
      }
    ).then(() => {
      setIsScanning(true);
      setError(null);
    }).catch(err => {
      console.error("Unable to start scanning:", err);
      setError("Unable to start camera scanning");
    });

    return () => {
      if (qrCodeInstance && isScanning) {
        qrCodeInstance.stop().catch(err => console.error("Cleanup error:", err));
      }
    };
  }, [selectedCamera, isOpen, onScan]);

  const handleClose = () => {
    if (html5QrCode && isScanning) {
      html5QrCode.stop().then(() => {
        setIsScanning(false);
        onClose();
      }).catch(err => {
        console.error("Error stopping scanner:", err);
        onClose();
      });
    } else {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal fade show d-block" style={{backgroundColor: 'rgba(0,0,0,0.8)'}}>
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">📱 Scan QR Code or Barcode</h5>
            <button 
              type="button" 
              className="btn-close" 
              onClick={handleClose}
            ></button>
          </div>
          <div className="modal-body">
            {error ? (
              <div className="alert alert-danger text-center">
                <p>{error}</p>
              </div>
            ) : (
              <>
                <div className="text-center mb-3">
                  <p>📷 Position the code within the scanning area</p>
                  <small>{isScanning ? "Scanning..." : "Starting camera..."}</small>
                </div>
                
                <div 
                  id="qr-reader" 
                  style={{ 
                    width: '100%',
                    border: '2px dashed #007bff',
                    borderRadius: '8px',
                    minHeight: '300px'
                  }}
                ></div>
              </>
            )}
          </div>
          <div className="modal-footer">
            <button 
              type="button" 
              className="btn btn-secondary" 
              onClick={handleClose}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QRScanner;
